<div *ngIf="loadComplete" class="container-block">



  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">

    <app-position-in-config [elementChoosing]="objectChoosing" [device]="device"
      [idCellFrame]="'cell_frame_'+ objectChoosing._id + '_' + '0' "></app-position-in-config>

    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['frame-cart-products']['width']" [height]="class['frame-cart-products']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="main-config">

          <!-- Option màu nền cho frame -->
          <app-background-image-config [showImageConfig]="false" [config]="config" [class]="class"
            [backgroundClass]="class['frame-cart-products']" [backgroundConfig]="config['frame-cart-products']"
            [isBlock]="false" [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>

        </div>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <app-total-row-col-products-config [config]="config" [class]="class"
          [productsClass]="class['frame-cart-products__products']"
          [productsConfig]="config['frame-cart-products__products']" [id_object]="objectChoosing._id" [device]="device">
        </app-total-row-col-products-config>
        <!-- Khoảng đệm -->
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-cart-products__products']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <input class="input-color" type="button"
              [style.background]="class['frame-cart-products__products--item']['background-color']" [cpOKButton]="true"
              [(colorPicker)]="class['frame-cart-products__products--item']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>

          <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
            [borderClass]="class['frame-cart-products__products--item']" [id_object]="objectChoosing._id">
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li *ngIf="config['frame-cart-products__products']['is_autoplay']" nz-submenu nzTitle="Cấu hình icon trái"
        [(nzOpen)]="openMenu.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-icon-left-config [device]="device" [class]="class" [config]="config"
          [iconLeftClass]="class['frame-cart-products__left-arrow--icon']"
          [iconLeftConfig]="config['frame-cart-products__left-arrow--icon']"
          [distanceLeftClass]="class['frame-cart-products__left-arrow']" [id_object]="objectChoosing._id">
        </app-icon-left-config>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li *ngIf="config['frame-cart-products__products']['is_autoplay']" nz-submenu nzTitle="Cấu hình icon phải"
        [(nzOpen)]="openMenu.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-icon-right-config [device]="device" [class]="class" [config]="config"
          [iconRightClass]="class['frame-cart-products__right-arrow--icon']"
          [iconRightConfig]="config['frame-cart-products__right-arrow--icon']"
          [distanceRightClass]="class['frame-cart-products__right-arrow']" [id_object]="objectChoosing._id">
        </app-icon-right-config>
      </li>
      <!-- Cấu hình khi không có sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_co_san_pham' | translate}}" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate }}</p>
          <nz-switch [(ngModel)]="config['isEmpty']"></nz-switch>
        </div>

        <ng-container *ngIf="config['isEmpty']">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">

          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate }}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="objectChoosing.staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticdata()"></textarea>
            </mat-form-field>
          </div>
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field title="Font" style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['frame-cart-products__no-products']['font-family']"
                  (ngModelChange)="updateClass()" [(value)]="class['frame-cart-products__no-products']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field title="Size" style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate }}</mat-label>
                <input matInput type="number" (blur)="updateClass()"
                  [ngModel]="class['frame-cart-products__no-products']['font-size'] | vhnumber"
                  (ngModelChange)="class['frame-cart-products__no-products']['font-size'] =$event + 'px'" />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button
                [nzType]=" class['frame-cart-products__no-products']['font-weight'] == 'bold' ? 'primary' : 'default' "
                (click)="class['frame-cart-products__no-products']['font-weight'] = class['frame-cart-products__no-products']['font-weight'] == 'bold' ? '500' : 'bold'; updateClass() ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['frame-cart-products__no-products']['font-style'] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-cart-products__no-products']['font-style'] =
                        class['frame-cart-products__no-products']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal';
                      updateClass()
                    ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['frame-cart-products__no-products']['text-decoration'] ==
                      'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-cart-products__no-products']['text-decoration'] =
                        class['frame-cart-products__no-products']['text-decoration'] ==
                        'none'
                          ? 'underline'
                          : 'none';
                      updateClass()
                    ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-line-through" title="Line-through" nz-button [nzType]="
                      class['frame-cart-products__no-products']['text-decoration'] ==
                      'line-through'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-cart-products__no-products']['text-decoration'] =
                        class['frame-cart-products__no-products']['text-decoration'] ==
                        'none'
                          ? 'line-through'
                          : 'none';
                      updateClass()
                    ">
                <i nz-icon nzType="strikethrough" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['frame-cart-products__no-products']['text-transform'] ==
                      'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-cart-products__no-products']['text-transform'] =
                        class['frame-cart-products__no-products']['text-transform'] ==
                        'none'
                          ? 'uppercase'
                          : 'none';
                      updateClass()
                    ">
                <span>AB</span>
              </button>
              <div>
                <input id="color" title="Color" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['frame-cart-products__no-products']['color']"
                  [style.background]="class['frame-cart-products__no-products']['color']"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
              </div>
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate }}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['frame-cart-products__no-products']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['frame-cart-products__no-products']['letter-spacing'] = $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-cart-products__no-products']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                  class['frame-cart-products__no-products']['letter-spacing'] = $event + 'px'
                "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'khoang_cach_dong' | translate }}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-cart-products__no-products']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-cart-products__no-products']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>

      <li nz-submenu nzTitle="{{'cau_hinh_thanh_cuon' | translate}}" [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <!-- Chiều rộng -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_rong" | translate}}</p>
          <nz-input-number [nzMin]="0" [nzStep]="1" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config?.['scrollbar']?.['width_scrollbar'] | vhnumber" (nzBlur)="updateConfig()" (ngModelChange)="
              config['scrollbar']['width_scrollbar'] = $event + 'px'
            "></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0" [nzStep]="1" [ngModel]="config?.['scrollbar']?.['width_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateConfig()" (ngModelChange)="
                config['scrollbar']['width_scrollbar'] = $event + 'px'
              "></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Chiều cao -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"chieu_cao" | translate}}</p>
          <nz-input-number [nzMin]="0" [nzStep]="1" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config?.['scrollbar']?.['height_scrollbar'] | vhnumber" (nzBlur)="updateConfig()"
            (ngModelChange)="
              config['scrollbar']['height_scrollbar'] = $event + 'px'
            "></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0" [nzStep]="1" [ngModel]="config?.['scrollbar']?.['height_scrollbar'] | vhnumber"
              (nzOnAfterChange)="updateConfig()" (ngModelChange)="
                config['scrollbar']['height_scrollbar'] = $event + 'px'
              "></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Màu nền nút kéo -->
        <div class="color-pick mb-2">
          <span class="title w-50" style="line-height: 1.3;">{{"nut_keo" | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="config['scrollbar']['background_color_thumb']"
            [style.background]="config['scrollbar']['background_color_thumb']" (colorPickerClose)="updateConfig()"
            [cpWidth]="'230px'" />
        </div>

        <div class="color-pick">
          <span class="title w-50" style="line-height: 1.3;">{{"phan_duong_dan" | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="config['scrollbar']['background_color_track']"
            [style.background]="config['scrollbar']['background_color_track']" (colorPickerClose)="updateConfig()"
            [cpWidth]="'230px'" />
        </div>

        <!-- Bo tròn nút kéo-->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_nut_keo" | translate}}</p>
          <nz-input-number [nzMin]="0" [nzStep]="1" [nzMax]="10" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config?.['scrollbar']?.['border_radius_thumb'] | vhnumber" (nzBlur)="updateConfig()"
            (ngModelChange)="
                config['scrollbar']['border_radius_thumb'] = $event + 'px'
              "></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0" [nzStep]="1" [nzMax]="10"
              [ngModel]="config?.['scrollbar']?.['border_radius_thumb'] | vhnumber" (nzOnAfterChange)="updateConfig()"
              (ngModelChange)="
                  config['scrollbar']['border_radius_thumb'] = $event + 'px'
                "></nz-slider>
          </nz-col>
        </nz-row>

        <!-- Bo tròn phần đường đi -->
        <div class="row-border">
          <p class="m-0 title-border" style="line-height: 1.5">{{"bo_tron_duong_di" | translate}}</p>
          <nz-input-number [nzMin]="0" [nzStep]="1" [nzMax]="10" [ngStyle]="{ marginLeft: '16px', width: '40%' }"
            [ngModel]="config?.['scrollbar']?.['border_radius_track'] | vhnumber" (nzBlur)="updateConfig()"
            (ngModelChange)="
                config['scrollbar']['border_radius_track'] = $event + 'px'
              "></nz-input-number>
        </div>
        <nz-row>
          <nz-col nzSpan="24">
            <nz-slider [nzMin]="0" [nzStep]="1" [nzMax]="10"
              [ngModel]="config?.['scrollbar']?.['border_radius_track'] | vhnumber" (nzOnAfterChange)="updateConfig()"
              (ngModelChange)="
                  config['scrollbar']['border_radius_track'] = $event + 'px'
                "></nz-slider>
          </nz-col>
        </nz-row>

      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['frame-cart-products']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMenu.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span> -->

    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['frame-cart-products']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-cart-products__products--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Bật đổ bóng -->

      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-cart-products__products--item']"
        [shadowConfig]="config['frame-cart-products__products--item']" [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
  </div>
</div>